<template>
    <f7-page
        name="New questions"
        class="onboardingBg"
    >
        <f7-navbar
            inner
            large
            title-large="New questions"
            no-hairline
            large-transparent
            inner-class="onboardingBg"
        >

            <f7-nav-left>
                <f7-link
                    icon="ion-ios-arrow-left"
                    @click="goBack"
                />
            </f7-nav-left>
            <f7-nav-title>New questions</f7-nav-title>
            <f7-nav-right />
        </f7-navbar>
        <f7-list v-if="newQuestions.length === 0 && isLoaded">
            <f7-list-item :title="'You don\'t have any new questions yet. '" />
        </f7-list>
        <f7-list
            v-else
            media-list
        >

            <sequential-entrance from-bottom>
                <template v-for="(unit, index) in newQuestions">
                    <unit-card
                        :unit="unitsIndex[unit.id]"
                        :key="`ask-reco-units-${index}`"
                        :home="true"
                        :in-card="true"
                        :index="index"
                        :pack="newQuestions"
                    />
                </template>
            </sequential-entrance>
        </f7-list>
    </f7-page>
</template>

<script>
import UnitCard from '../../components/unitCard.vue';

import utils from '../../js/utils';

export default {
    store: ['api', 'newQuestions', 'unitsIndex', 'units', 'topicsIndex'],
    components: {
        UnitCard
    },
    data () {
        return {
            isLoaded: false
        };
    },
    mounted: function () {
        if (!this.newQuestions.length)
            this.createNewUnits();
    },
    methods: {
        goBack: function () {
            if (f7.views['main'].router.history.length === 1) {
                return f7.views['main'].router.navigate('/home', { clearPreviousHistory: true });
            }
            return f7.views['main'].router.back();
        },
        lessThan30DayOld: function (unit) {
            var fortnightAway = new Date(Date.now() - (12096e5 * 2));
            if ((new Date(unit.createdAt).getTime() - fortnightAway.getTime()) > 0) {
                return true;
            }
            return false;
        },
        createNewUnits: function () {
            this.newQuestions = [];
            let units = this.units.slice().sort((a, b) => {
                var dateA = new Date(a.createdAt);
                var dateB = new Date(b.createdAt);
                return dateA - dateB;
            }).reverse();
            for (let i = 0; i < units.length; i++) {
                const u = units[i];
                if (!u.completed &&
                    !u.started &&
                    u.type === 'question' &&
                    this.lessThan30DayOld(u) &&
                    utils.checkTraits(this.myTraits, u) &&
                    this.newQuestions.indexOf(u) === -1) {
                    this.newQuestions.push(u);
                }
            }
        },
    }
};
</script>
<style lang="less" scoped>
@import '../../css/colors.less';
.center {
    text-align: center;
    width: 100%;
}
</style>
